<script>
import { mapGetters } from 'vuex';
import VSelect from '@/components/Common/VSelect';
import wordEnding from '@/utils/wordEnding';
import priceFormat from '@/utils/priceFormat';

const SORTING = [
  {
    id: 0,
    name: 'По умолчанию',
    order_by: null,
    dir: null,
  },
  {
    id: 1,
    name: 'дате в порядке возрастания',
    order_by: 'date',
    dir: 'asc',
  },
  {
    id: 2,
    name: 'дате в порядке убывания',
    order_by: 'date',
    dir: 'desc',
  },
  {
    id: 3,
    name: 'цене от меньшей к большей',
    order_by: 'price',
    dir: 'asc',
  },
  {
    id: 4,
    name: 'цене от большей к меньшей',
    order_by: 'price',
    dir: 'desc',
  },
  {
    id: 5,
    name: 'году выпуска в порядке возрастания',
    order_by: 'year',
    dir: 'asc',
  },
  {
    id: 6,
    name: 'году выпуска в порядке убывания',
    order_by: 'year',
    dir: 'desc',
  },
  {
    id: 7,
    name: 'пробегу от меньшему к большему',
    order_by: 'mileage',
    dir: 'asc',
  },
  {
    id: 8,
    name: 'пробегу от большему к меньшему',
    order_by: 'mileage',
    dir: 'desc',
  },
];

const PER_PAGE = [
  {
    id: 1,
    name: 12,
  },
  {
    id: 2,
    name: 24,
  },
  {
    id: 3,
    name: 48,
  },
  {
    id: 4,
    name: 96,
  },
];

export default {
  name: 'MainFilterSorting',
  components: {
    VSelect,
  },
  props: {
    countCarsCurrentCity: {
      type: Number,
      required: true,
    },
    resetSorting: {
      type: Boolean,
      default: false,
    },
  },
  SORTING,
  PER_PAGE,
  wordEnding,
  priceFormat,
  data() {
    return {
      sorting: {
        sort: this.$options.SORTING[0],
        perPage: this.$options.PER_PAGE[1],
      },
      currentCountCityCars: this.countCarsCurrentCity,
    };
  },
  watch: {
    countCityCars() {
      this.currentCountCityCars = this.countCityCars;
    },
    resetSorting() {
      if (this.resetSorting) {
        this.sorting.sort = this.$options.SORTING[0];
        this.sorting.perPage = this.$options.PER_PAGE[1];
        this.$emit('change-sorting', this.sorting);
      }
    },
  },
  created() {
    if (this.getParam('sort_type')) {
      const order_by = this.getParam('sort_type').split('|')[0];
      const dir = this.getParam('sort_type').split('|')[1];

      this.sorting.sort = this.$options.SORTING.find(
        e => e.order_by === order_by && e.dir === dir,
      );
    }
    if (this.getParam('per_page')) {
      this.sorting.perPage = this.$options.PER_PAGE.find(
        e => e.name === Number(this.getParam('per_page')),
      );
    }

    this.$emit('change-sorting', this.sorting);
  },
  computed: {
    ...mapGetters({
      countCityCars: 'Filter/countCityCars',
    }),
  },
  methods: {
    getParam(name) {
      const query = window.location.search.replace('?', '').split('&');
      let param = null;

      if (window.location.search !== '') {
        query.forEach(element => {
          if (element.split('=')[0].replace('%5B%5D', '') === name) {
            if (element.includes('%5B%5D')) {
              if (!param) {
                param = [];
              }
              param.push(element.split('=')[1]);
            } else {
              param = element.split('=')[1];
            }
          }
        });
      }

      return param;
    },
    changeSorting() {
      if (!this.sorting.sort) {
        this.sorting.sort = this.$options.SORTING[0];
      }
      if (!this.sorting.perPage) {
        this.sorting.perPage = this.$options.PER_PAGE[1];
      }
      this.$emit('change-sorting', this.sorting);
      this.$emit('update-filter');
    },
  },
};
</script>

<template>
  <div class="w-full mb-5 pt-[50px]" id="car-sort">
    <div
      class="flex items-center justify-between flex-wrap gap-x-8 p-5 pb-2 rounded-big-brand bg-white"
    >
      <div class="flex flex-wrap gap-x-8">
        <div class="flex items-center max-w-full mb-3">
          <div
            class="text-sm sm:text-base text-gray-600 leading-none sm:leading-none mr-3"
          >
            Сортировать&nbsp;по:
          </div>
          <v-select
            v-model="sorting.sort"
            :options="$options.SORTING"
            class="w-auto sm:w-64 max-w-[195px] sm:max-w-full text-sm sm:text-base"
            @change-value="changeSorting"
          ></v-select>
        </div>

        <div class="flex items-center mb-3">
          <div
            class="text-sm sm:text-base leading-none sm:leading-none text-gray-600 mr-3"
          >
            Показывать&nbsp;по:
          </div>
          <v-select
            v-model="sorting.perPage"
            :options="$options.PER_PAGE"
            class="w-20 text-sm sm:text-base"
            @change-value="changeSorting"
          ></v-select>
        </div>
      </div>

      <div class="text-gray-600 mb-3">
        {{
          `Найдено ${$options.priceFormat(currentCountCityCars)} ${$options.wordEnding(currentCountCityCars, ['автомобиль', 'автомобиля', 'автомобилей'])}`
        }}
      </div>
    </div>
  </div>
</template>
